import { useIntl } from 'react-intl';
import { sellingPointsMessages } from './messages';
import type { SellingPointsProps } from './types';

export const SellingPoints = ({ sellingPoints, orderNumber, promotion }: SellingPointsProps) => {
  const { formatMessage } = useIntl();

  return (
    <ul aria-labelledby="selling-points" className="text-size-body2 list-disc">
      {sellingPoints.map((sellingPoint, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={`sellingpoints${index}`}>{sellingPoint}</li>
      ))}
      <li>
        {formatMessage(sellingPointsMessages.articleNumber, {
          data: orderNumber + promotion,
        })}
      </li>
    </ul>
  );
};
